import CustomSharedTitleSection from "sipli-fleet-core/components/CustomSharedTitleSection/CustomSharedTitleSection";

type Props = {
  titleKey: "tachograph_download_log" | "tachograph_models";
};

export default function TachographBlankPage({ titleKey }: Props) {
  return (
    <section className="min-h-screen bg-gray1 pb-8">
      <CustomSharedTitleSection
        titleKey={titleKey}
        level={1}
        showBtn={false}
        titleClassName="!text-2xl !font-bold"
      />
    </section>
  );
}
